export default "__VITE_ASSET__BbMpD_Ab__"